import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  withStyles,
} from '@material-ui/core';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
  }
});

class LoginGoogle extends React.Component {
  render() {
    try {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));

      const urlState = hashParams.get('state');
      const storageState = localStorage.getItem('stateGoogle');
      console.log({storageState, urlState});
      if (storageState === urlState) {
        console.log({storageState, urlState, same: 'true'});
        const accessToken = hashParams.get('access_token');
        const idToken = hashParams.get('id_token');
        console.log({accessToken, idToken});

        localStorage.setItem('token', `${accessToken} ${idToken}`);
        localStorage.setItem('userType', 'google');
        window.location.reload();
        return <Navigate to='/app/dashboard'/>;
      } else {
        alert('State is invalid. Please login again');
        return <Navigate to='/app/login'/>;
      }
    } catch (error) {
      alert('Something went wrong. Please login again');
      return <Navigate to='/app/login'/>;
    }
  }
}

LoginGoogle.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(LoginGoogle);
